import React from 'react'
import { DividendsList } from './list/page'

export const DividendsPage = (): JSX.Element => {
  return <DividendsList></DividendsList>
}
